/* ••[1]••••••••••••••••••••••••• testimonialQuoteVm.ts •••••••••••••••••••••••••••••• */

import { CustomElement } from "../../core/CustomElement";
import {
  TestimonialQuote,
  validatedTestimonialQuote,
} from "../../core/types/TestimonialQuote";

import ko from "knockout";

export default class TestimonialQuoteVm {
  $customElement: CustomElement;
  testimonialQuote: KnockoutObservable<TestimonialQuote>;
  backgroundImage =
    "https://www.oracle.com/webfolder/community/ccc/prod/images/backgrounds/quote.png";

  constructor($customElement: CustomElement) {
    this.$customElement = $customElement;
    this.testimonialQuote = ko.observable({} as TestimonialQuote);
  }

  public display(): boolean {
    return !!validatedTestimonialQuote(this.testimonialQuote());
  }
}
